// extracted by mini-css-extract-plugin
export default {"button":"vp-z","reviewSort":"wp-z"};